import { render } from "./TrustWallet.vue?vue&type=template&id=11764595&scoped=true"
import script from "./TrustWallet.vue?vue&type=script&lang=js"
export * from "./TrustWallet.vue?vue&type=script&lang=js"

import "./TrustWallet.vue?vue&type=style&index=0&id=11764595&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11764595"]])

export default __exports__